function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  cx: -578.95,
  cy: -837.6,
  gradientTransform: "matrix(.75 0 0 .75 499.5 629.5)",
  gradientUnits: "userSpaceOnUse",
  id: "prefix__radial-gradient",
  r: 197.06
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f9ed32"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#ee2a7b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#d22a8a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#8b2ab2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#1b2af0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#002aff"
})), /*#__PURE__*/React.createElement("style", null, ".prefix__cls-2{fill:#fff}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "3-instagram",
  id: "prefix___3-instagram"
}, /*#__PURE__*/React.createElement("rect", {
  height: 64,
  rx: 11.2,
  ry: 11.2,
  transform: "rotate(180 32 32)",
  width: 64,
  fill: "url(#prefix__radial-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__cls-2",
  d: "M44 56H20A12 12 0 018 44V20A12 12 0 0120 8h24a12 12 0 0112 12v24a12 12 0 01-12 12zM20 12.8a7.21 7.21 0 00-7.2 7.2v24a7.21 7.21 0 007.2 7.2h24a7.21 7.21 0 007.2-7.2V20a7.21 7.21 0 00-7.2-7.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__cls-2",
  d: "M32 45.6A13.6 13.6 0 1145.6 32 13.61 13.61 0 0132 45.6zm0-22.4a8.8 8.8 0 108.8 8.8 8.81 8.81 0 00-8.8-8.8z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "prefix__cls-2",
  cx: 45.6,
  cy: 19.2,
  r: 2.4
}));

function SvgInst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.9ccb00c843588fc89ded04a95d79e648.svg";
export { ForwardRef as ReactComponent };